import {EventEmitter} from '@angular/core';
import {HttpParams} from '@angular/common/http';
import {BehaviorSubject} from 'rxjs';
import {IFilter} from '../../services/IFilter';

export class ManagedCommandFilter implements IFilter {
  anyChange: EventEmitter<any> = new EventEmitter<any>();

  companyIdChange: BehaviorSubject<any> = new BehaviorSubject<any>('');

  get companyId(): any {
    return this.companyIdChange.value;
  }

  set companyId(companyId: any) {
    this.companyIdChange.next(companyId);
    this.emitChange('companyId', companyId);
  }

  nameChange: BehaviorSubject<any> = new BehaviorSubject<any>('');

  get name(): any {
    return this.nameChange.value;
  }

  set name(name: any) {
    this.nameChange.next(name);
    this.emitChange('name', name);
  }

  codeChange: BehaviorSubject<any> = new BehaviorSubject<any>('');

  get code(): any {
    return this.codeChange.value;
  }

  set code(code: any) {
    this.codeChange.next(code);
    this.emitChange('code', code);
  }

  commandTypeChange: BehaviorSubject<any> = new BehaviorSubject<any>('');

  get commandType(): any {
    return this.commandTypeChange.value;
  }

  set commandType(commandType: any) {
    this.commandTypeChange.next(commandType);
    this.emitChange('commandType', commandType);
  }

  enabledChange: BehaviorSubject<any> = new BehaviorSubject<any>('');

  get enabled(): any {
    return this.enabledChange.value;
  }

  set enabled(enabled: any) {
    this.enabledChange.next(enabled);
    this.emitChange('enabled', enabled);
  }

  emitChange(prop: string, value: any): void {
    this.anyChange.emit({prop: prop, value: value});
  }

  getParams(): HttpParams {
    let params = new HttpParams();

    if (this.companyId && this.companyId !== '') {
      params = params.set('companyId', this.companyId);
    }
    if (this.name && this.name !== '') {
      params = params.set('name', this.name);
    }
    if (this.code && this.code !== '') {
      params = params.set('code', this.code);
    }
    if (this.commandType && this.commandType !== '') {
      params = params.set('commandType', this.commandType);
    }
    if (this.enabled && this.enabled !== '') {
      params = params.set('enabled', this.enabled);
    }

    return params;
  }

  setFilters(props: any): void {
    this.companyIdChange.next(props.companyId || undefined);
    this.nameChange.next(props.name || undefined);
    this.codeChange.next(props.code || undefined);
    this.commandTypeChange.next(props.commandType || undefined);
    this.enabledChange.next(props.enabled || undefined);
  }

  toObj(): any {
    return {
      companyId: this.companyId,
      name: this.name,
      code: this.code,
      commandType: this.commandType,
      enabled: this.enabled
    };
  }

  clear(): void {
    this.companyId = undefined;
    this.name = undefined;
    this.code = undefined;
    this.commandType = undefined;
    this.enabled = undefined;
  }
}
